import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import { toast } from 'react-hot-toast';

const FreePassModal = ({ open, onClose, onConfirm, order }) => {
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!open || !order) return null;

    const handleSubmit = async () => {
        if (!reason.trim()) {
            toast.error('Debes ingresar una nota explicando el motivo del Pase Libre.');
            return;
        }

        if (reason.trim().length < 5) {
            toast.error('La nota debe ser más descriptiva.');
            return;
        }

        setIsSubmitting(true);
        try {
            await onConfirm(reason);
            onClose();
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden border-2 border-amber-400">

                {/* Header Dorado */}
                <div className="bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-600 p-6 text-white text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
                    <div className="relative z-10 flex flex-col items-center">
                        <div className="p-3 bg-white/20 rounded-full mb-3 shadow-inner backdrop-blur-sm">
                            <Icons.Ticket className="w-10 h-10 text-white drop-shadow-md" />
                        </div>
                        <h2 className="text-2xl font-black uppercase tracking-wider drop-shadow-sm">
                            Pase Libre Admin
                        </h2>
                        <p className="text-amber-100 text-sm font-medium mt-1">
                            Forzar cambio de estado para Pedido #{order.order_number}
                        </p>
                    </div>
                </div>

                <div className="p-6">
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 flex items-start gap-3">
                        <Icons.AlertTriangle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                        <div>
                            <h3 className="text-amber-800 font-bold text-sm">¡Atención!</h3>
                            <p className="text-amber-700 text-sm mt-1">
                                Estás a punto de forzar la entrega de este pedido, <strong>saltando las validaciones de saldo y cartera</strong>.
                                Esta acción quedará registrada en el historial bajo tu usuario.
                            </p>
                        </div>
                    </div>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-1">
                                Motivo del Pase Libre <span className="text-rose-500">*</span>
                            </label>
                            <textarea
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Ej: Cliente autorizado por Gerencia, Saldo a favor en Siigo no reflejado..."
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 min-h-[100px] text-sm"
                                autoFocus
                            />
                            <p className="text-xs text-gray-500 mt-1 text-right">
                                Mínimo 5 caracteres
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 mt-8">
                        <button
                            onClick={onClose}
                            disabled={isSubmitting}
                            className="px-4 py-2 text-gray-700 font-bold hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={isSubmitting || !reason.trim()}
                            className="px-6 py-2 bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700 text-white font-black rounded-lg shadow-md hover:shadow-lg transform active:scale-95 transition-all flex items-center gap-2"
                        >
                            {isSubmitting ? (
                                <>
                                    <Icons.Loader2 className="w-5 h-5 animate-spin" />
                                    Procesando...
                                </>
                            ) : (
                                <>
                                    <Icons.Unlock className="w-5 h-5" />
                                    Confirmar Pase Libre
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FreePassModal;
